import { Action } from '@ngrx/store';
import { BlueData } from '../models/blue-data.model';

export enum BlueDataActionTypes {
  BLUEDATA_QUERY = '[BlueData] Query',
  BLUEDATA_LOADED = '[BlueData] Fetched',

  BLUEDATA_ADDED = '[BlueData] Added',
  BLUEDATA_EDITED = '[BlueData] Edited',
  BLUEDATA_DELETED = '[BlueData] Deleted',
  BLUEDATA_SAVED = '[BlueData] Saved',

  BLUEDATA_ERROR = '[BlueData] Error'
}

export class BlueDataQuery implements Action {
  readonly type = BlueDataActionTypes.BLUEDATA_QUERY;
}

export class BlueDataLoaded implements Action {
  readonly type = BlueDataActionTypes.BLUEDATA_LOADED;

  constructor(public payload: { bluedatas: BlueData[] }) {}
}

export class BlueDataAdded implements Action {
  readonly type = BlueDataActionTypes.BLUEDATA_ADDED;

  constructor(public payload: { bluedata: BlueData }) {}
}

export class BlueDataEdited implements Action {
  readonly type = BlueDataActionTypes.BLUEDATA_EDITED;

  constructor(public payload: { bluedata: BlueData }) {}
}

export class BlueDataSaved implements Action {
  readonly type = BlueDataActionTypes.BLUEDATA_SAVED;

  constructor(public payload: {bluedata: BlueData}) {}
}

export class BlueDataDeleted implements Action {
  readonly type = BlueDataActionTypes.BLUEDATA_DELETED;

  constructor(public payload: { bluedata: BlueData }) {}
}

export class BlueDataError implements Action {
  readonly type = BlueDataActionTypes.BLUEDATA_ERROR;

  constructor(public payload: { error: any }) {}
}

export type BlueDataActions =
  | BlueDataQuery
  | BlueDataLoaded
  | BlueDataAdded
  | BlueDataEdited
  | BlueDataSaved
  | BlueDataDeleted
  | BlueDataError;
